import select from './select';

/* This script will make sure there's at least 1 option selected on form submit
 * Otherwise the search won't be triggered when user is sent to momentum
 * If not option is selected, we'll force selecting the 1st option of 1st select
 * In our case, it is Böstader (category) > Bostad (type)
 */
const formApartmentRedirect = (() => {
  const config = {
    triggers: [...document.querySelectorAll('.js-formApartmentParent')],
    category: '.js-isCategorySelected',
    type: '.js-isTypeSelected',
    form: '.js-formApartment',
  };

  const handleSubmit = ({ category, type }) => {
    // check if category is checked
    if (category.checked) {
      // if select has no selected option
      // then put it back to our desired type value - which is 3 (bostad)
      const isDisabledOptionSelected = type.options[type.selectedIndex].disabled;

      if (isDisabledOptionSelected) {
        // let's force a default value on the search
        // get the correct option
        const targetOption = [...type.options].filter(o => parseFloat(o.value) === 3)[0];
        // select that option
        targetOption.selected = true;
        // update the custom select
        select.update(type);
      }
    }
  };

  const build = () => {
    config.triggers.forEach((container) => {
      // get bostadstyp select
      const type = container.querySelector(config.type);
      // get category
      const category = container.querySelector(config.category);
      // the form
      const form = container.querySelector(config.form);
      // add event listener on form
      form.addEventListener('submit', () => handleSubmit({ category, type }));
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default formApartmentRedirect.init();
